import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

// Service for PartyCategoryMaster APIs
export const partyCategoryMasterService = createApi({
  reducerPath: "partyCategoryMasterService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["partyCategoryMaster"],
  endpoints: (builder) => ({
    // Pagination + Sorting
    getAllPartyCategoryMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.partyCategoryMasterController.getAllPartyCategoryMaster}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    // Search
    getAllPartyCategoryMasterBySearch: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.partyCategoryMasterController.getAllPartyCategoryMasterBySearch}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),

    // Get By ID
    getPartyCategoryMasterById: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.partyCategoryMasterController.getPartyCategoryMasterById}/${body.id}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    // Save
    savePartyCategoryMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.partyCategoryMasterController.savePartyCategoryMaster}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),

    // Update
    updatePartyCategoryMaster: builder.mutation({
      query(body) {
          console.log(body ,"body");
        return {
          url: `${userManagement.partyCategoryMasterController.updatePartyCategoryMaster}/${body.id}`,
          method: "PUT",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),

    // Delete
    deletePartyCategoryMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.partyCategoryMasterController.deletePartyCategoryMaster}/${body.id}`,
          method: "DELETE",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    // Get All (no pagination)
    findAllPartyCategoryMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.partyCategoryMasterController.findAllPartyCategoryMaster}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    // Bulk Upload (XLSX)
    bulkSavePartyCategoryMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.partyCategoryMasterController.bulkSavePartyCategoryMaster}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload, // formData with file
        };
      },
    }),
  }),
});

export const {
  useGetAllPartyCategoryMasterMutation,
  useGetAllPartyCategoryMasterBySearchMutation,
  useGetPartyCategoryMasterByIdMutation,
  useSavePartyCategoryMasterMutation,
  useUpdatePartyCategoryMasterMutation,
  useDeletePartyCategoryMasterMutation,
  useFindAllPartyCategoryMasterMutation,
  useBulkSavePartyCategoryMasterMutation,
} = partyCategoryMasterService;
